import { $axios } from "../../config/axios";
import ShrimpTalk from "../../model/shrimptalk";
import { cloneDeep } from "lodash";
import bkPermissions from "@/constants/bkPermissions";
import ShrimpTalkService from "../../services/ShrimpTalkService";
const state = {
  shrimpTalks: [],
  mapStidSt: new Map(),
};
const getters = {
  getShrimpTalks: (state) => {
    return state.shrimpTalks.map((st) => {
      return cloneDeep(st);
    });
  },
  getObjStIdSt: (state) => {
    const arrSts = state.shrimpTalks;
    const objStIdSt = {};
    arrSts.forEach((st) => {
      objStIdSt[st._id] = st;
    });
    return objStIdSt;
  },
  getMapStidSt: (state) => state.mapStidSt,
};
const mutations = {
  SET_SHRIMP_TALK_DATA: function(state, shrimpTalkData) {
    if (shrimpTalkData != null) {
      const stArr = [];
      shrimpTalkData.forEach((shrimptalk) => {
        const stObj = new ShrimpTalk();
        stObj.castToSTObj(shrimptalk);
        stArr.push(stObj);
      });
      state.shrimpTalks = stArr;
    } else {
      state.shrimpTalks = null;
    }
  },
  SET_MAP_STID_ST(state) {
    const mapStidSt = new Map();
    state.shrimpTalks.forEach((st) => {
      mapStidSt.set(st.shrimp_talk_id, st);
    });
    state.mapStidSt = mapStidSt;
  },
};
const actions = {
  fetchAllShrimpTalks: function(context, queryParams = {}) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/shrimp-talks", {
          params: queryParams,
        })
        .then((response) => {
          context.commit("SET_SHRIMP_TALK_DATA", response.data.shrimp_talks);
          context.commit("SET_MAP_STID_ST");
          resolve({
            message: response.data.message,
            totalSTs: response.data.total,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAShrimpTalk: function(context, shrimpTalkId) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/shrimp-talks/" + shrimpTalkId)
        .then((response) => {
          resolve(response.data.shrimp_talk);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchShrimpTalksOnPondId: async function(context, { pondId, params }) {
    const requiredPermissions = bkPermissions["/ponds/:pond_id/pond-mothers"];
    const canAccessApi = context.rootGetters[
      "user/canUserAccessApiByBkPermissions"
    ](requiredPermissions);
    if (!canAccessApi) {
      console.error("No Permissions to call this api");
      return [];
    }
    const response = await ShrimpTalkService.fetchStDetailsByPondId(
      pondId,
      params
    );
    return response.data.shrimp_talks;
  },
  addShrimpTalkDetails: function(context, shrimpTalks) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/ponds/shrimp-talks", shrimpTalks)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateShrimpTalkDetails: function(context, shrimpTalks) {
    return new Promise((resolve, reject) => {
      $axios
        .patch("/ponds/shrimp-talks", shrimpTalks)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateShrimpTalkSettingDetails: function(context, shrimpTalks) {
    return new Promise((resolve, reject) => {
      $axios
        .patch("/ponds/shrimp-talks/settings", shrimpTalks)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  unAssignShrimpTalks: function(context, shrimpTalks) {
    return new Promise((resolve, reject) => {
      $axios
        .delete(`/ponds/shrimp-talks/${shrimpTalks}`)
        .then((response) => {
          // context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addPondMotherToShrimpTalk: async function(context, { query: stId, params }) {
    const response = await ShrimpTalkService.addPondMotherToShrimpTalk(
      stId,
      params
    );
    return response.data;
  },
  removePondMotherFromShrimpTalk: async function(
    context,
    { query: stId, params }
  ) {
    const response = await ShrimpTalkService.removePondMotherFromShrimpTalk(
      stId,
      params
    );
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
